import {
    ADD_ERROR,
    ACK_ERROR,
    ADD_ALERT,
    ACK_ALERT,
} from 'redux/notifications/actions'

import { remove } from 'lodash'

const initialState = {
    error: null,
    info: null,
    alerts: [],
}

export const notifications = (state = initialState, {type, message, alert, id}) => {

    switch (type)
    {
        case ADD_ERROR:
            return {
                ...state,
                error: {
                    message,
                }
            }
        case ACK_ERROR:
            return {
                ...state,
                error: null,
            }
        
        case ADD_ALERT:
            return {
                ...state,
                alerts: [
                    ...state.alerts,
                    alert
                ]
            }
            
        case ACK_ALERT:
            const alerts = [...state.alerts]
            remove(alerts, function(alert) {
                return alert.id === id
            });
            
            return {
                ...state,
                alerts,
            }
        
        default:
            return state
    }
}
